import React, { useCallback, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

import Step from '../../../../../../../features/components/Forms/StepForm/Step'
import RadioBlock from '../../../../../../../components/Form/RadioBlock'

import { AD_CREATIVE_TYPE, CAMPAIGN_MANAGER_THIRD_PARTY_CREATIVE_TAGS, CREATIVE_FILE_UPLOAD } from '../../fields'

function AdCreativeTypeStep({ manageStepFormRoutes, handleStepChange }) {
  const { t } = useTranslation()

  const { selectedRoute, handleSelectRoute, routeWasSelected } = manageStepFormRoutes
  // chooseRoute just handle the UI and selectedRoute manage actual route
  const [chooseRoute, setChooseRoute] = useState(selectedRoute)

  const handleContinue = useCallback(() => {
    if (selectedRoute === chooseRoute) {
      // route wasn't change
      handleStepChange()
    } else {
      // selected new route
      handleSelectRoute(chooseRoute)
    }
  }, [chooseRoute, handleSelectRoute, handleStepChange, selectedRoute])

  useEffect(() => {
    routeWasSelected && handleStepChange()
    // eslint-disable-next-line
  }, [])

  return (
    <Step stepTitle="Please select type of ad creative" handleContinue={handleContinue}>
      <RadioBlock
        setFieldValue={(fieldName, route) => setChooseRoute(route)}
        id={AD_CREATIVE_TYPE + CREATIVE_FILE_UPLOAD}
        name={AD_CREATIVE_TYPE}
        label={t('Creative File Upload')}
        value={CREATIVE_FILE_UPLOAD}
        selectedValue={chooseRoute}
      />
      <RadioBlock
        setFieldValue={(fieldName, route) => setChooseRoute(route)}
        id={AD_CREATIVE_TYPE + CAMPAIGN_MANAGER_THIRD_PARTY_CREATIVE_TAGS}
        name={AD_CREATIVE_TYPE}
        label={t('Campaign Manager Third Party Creative Tags')}
        value={CAMPAIGN_MANAGER_THIRD_PARTY_CREATIVE_TAGS}
        selectedValue={chooseRoute}
      />
    </Step>
  )
}

export default AdCreativeTypeStep
